export enum PageMode {
  Empty = 1,
  Review = 2,
  Add = 3,
  Edit = 4,
}

// 排序方式
export enum SortType {
  // 不排序
  None = '',
  // 升序
  Asc = 'asc',
  // 降序
  Desc = 'desc',
}

// 时间阶段标识
export enum PeriodFlag {
  // 历史的
  History = '1',
  // 未来的
  Future = '2',
}

export const getPeriodFlagName = (
  value: PeriodFlag | (string & {}),
  params?: { historyName?: string; futureName?: string },
): string => {
  const { historyName, futureName } = params || {};
  if (value === PeriodFlag.History) {
    return historyName || 'Actual';
  }
  if (value === PeriodFlag.Future) {
    return futureName || 'Budget';
  }
  return '';
};

export enum BoolFlag {
  True = '1',
  False = '0',
}

export const reverseBoolFlag = (value: BoolFlag): BoolFlag =>
  value === BoolFlag.True ? BoolFlag.False : BoolFlag.True;

// 数据来源（常用于表格中，区分系统自动拉取的数据，和用户手动添加的数据）
export enum DataType {
  // 系统自动拉取的数据
  AutoFetched = 1,
  // 用户手动添加的数据
  ManualAdded = 2,
}
